<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">{{ $tc("settings.promotion", 2) }}</h2>

    <div class="columns">
      <div class="column">
        <p><b>Dia dos namorados 2024 - 12 e 13 de junho</b></p>
        <br />

        <p>Esta promoção consistirá em:</p>
        <br />

        <ul>
          <li>
            → Cashback de 15% para todas as compras feitas via pagamento PIX.
          </li>

          <li>
            → A franqueadora entrará com 7,5%, a serem abatidos dos royalties.
          </li>

          <li>
            <b>→ Campanha válida para apenas franqueados.</b>
          </li>

          <!-- <li>
            →
            <span
              @click="isInitialCartPopUpOpen = true"
              style="color: blue; cursor: pointer;"
            >
              <u>Banner informativo</u>
            </span>
            para quando o cliente entrar na loja (app - tela do carrinho)
          </li> -->
        </ul>
        <br />

        <b-field :label="$t('settings.participate')">
          <b-switch
            size="is-small"
            class="promotion-switch"
            type="is-primary"
            v-model="storeBeingManaged.promotions.diaDosNamorados2024"
            passive-type="is-secondary"
            @input="participateInPromotion('diaDosNamorados2024')"
          ></b-switch>

          {{
            storeBeingManaged.promotions.diaDosNamorados2024
              ? $t("common.yes")
              : $t("common.no")
          }}
        </b-field>

        <p>
          <br />
          <b>Atenção:</b>
        </p>

        <ul>
          <li>→ Para participar, basta selecionar "Sim" acima.</li>

          <li>
            → Se houver cashbacks conflitantes com os desta promoção nesta loja,
            eles serão desconsiderados durante o período desta promoção
          </li>

          <li>
            → Obs: cashbacks mais específicos não são conflitantes com cashbacks
            menos específicos (produto > subcategoria > categoria > loja toda)
          </li>

          <li>
            → Para mais informações, visite a
            <a
              href="https://www.notion.so/onii/JUN-12-Dia-dos-Namorados-9db76019e9724bd18623888c0aa3e1d0"
              target="_blank"
            >
              página da promoção no manual do licenciado
            </a>
          </li>
        </ul>
      </div>
    </div>

    <b-modal :active.sync="isInitialCartPopUpOpen">
      <p class="image" @click="isInitialCartPopUpOpen = false">
        <img
          src="https://assets.onii.app/promotions/2024/06/dia-dos-namorados-2024.png"
          style="width: 300px; height: 400px; margin: auto;"
        />
      </p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      isInitialCartPopUpOpen: false
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged"])
  },

  methods: {
    participateInPromotion(promotion) {
      this.isLoading = true;
      this.$store
        .dispatch("participateInPromotion", {
          promotion,
          status: this.storeBeingManaged.promotions.diaDosNamorados2024,
          storeId: this.storeBeingManaged._id
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
            this.storeBeingManaged.promotions.diaDosNamorados2024 = !this
              .storeBeingManaged.promotions.diaDosNamorados2024;
          } else {
            this.$buefy.toast.open({
              message: `${this.$tc("settings.promotion", 1)} ${
                this.storeBeingManaged.promotions.diaDosNamorados2024
                  ? this.$t("common.enabled-f")
                  : this.$t("common.disabled-f")
              }!`,
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          }
        })
        .catch(() => {
          this.storeBeingManaged.promotions.diaDosNamorados2024 = !this
            .storeBeingManaged.promotions.diaDosNamorados2024;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.promotion-switch {
  position: relative;
  top: 2px;
}
</style>
